import { useEffect, useState } from 'react';

const Sitemap = () => {
  const [sitemapContent, setSitemapContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch sitemap.xml from public folder
    const sitemapUrl = `${process.env.PUBLIC_URL || ''}/sitemap.xml`;
    fetch(sitemapUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Sitemap not found');
        }
        return response.text();
      })
      .then(xml => {
        setSitemapContent(xml);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading sitemap:', error);
        setSitemapContent('<?xml version="1.0" encoding="UTF-8"?><urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"><url><loc>Error: Sitemap not found</loc></url></urlset>');
        setLoading(false);
      });
  }, []);

  // Set content type for XML
  useEffect(() => {
    if (!loading && sitemapContent) {
      // Try to set content type via meta tag (though this won't change HTTP headers)
      const meta = document.createElement('meta');
      meta.httpEquiv = 'Content-Type';
      meta.content = 'application/xml; charset=utf-8';
      document.head.appendChild(meta);
    }
  }, [loading, sitemapContent]);

  if (loading) {
    return <div>Loading sitemap...</div>;
  }

  // Return XML content
  return (
    <div style={{ 
      fontFamily: 'monospace', 
      whiteSpace: 'pre-wrap', 
      wordWrap: 'break-word',
      padding: '20px',
      backgroundColor: '#f5f5f5'
    }}>
      <pre style={{ margin: 0 }}>{sitemapContent}</pre>
    </div>
  );
};

export default Sitemap;

